import { useQuerySearchState } from "@/hooks/use-query-search-state";
import { useGetUserQuery } from "@/queries/query-user";

export const USER_SEARCH_KEY = "user";
export const useAdminTenantUserList = () => {
  const getUserQuery = useGetUserQuery();
  const {
    data: user,
    setData: setUser,
    isLoading: userIsLoading,
  } = useQuerySearchState(USER_SEARCH_KEY, getUserQuery, {});
  return { user, setUser, userIsLoading };
};
